export const getUser = store => {
  return store.user
}

export const getAuthStatus = store => {
  return store.isAuthenticated
};
